import { text as portugues } from "./translates/ptBr";
import { text as english } from "./translates/enUs";

export const text = {
  ...portugues,
  ...english,
};
